import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const DirectSaleDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch<{ directSaleId: string }>();

  useEffect(() => {
    if (match.isExact) {
      const { directSaleId } = match.params;

      history.replace(`/app/movements/directSale/${directSaleId}/general`);
    }
  }, [match]);

  return null;
};

export default DirectSaleDetailsPage;
